// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__27Mh2","fileBtn":"File_fileBtn__2ZY_H","closeBtn":"File_closeBtn__3DLQe","fileSelected":"File_fileSelected__25BNX","disabled":"File_disabled__1AtYm"};